export {
  RegisterAccountForm,
  type RegisterAccountFormProps,
  type RegisterAccountFormFields,
} from "~/components/RegisterAccountForm/RegisterAccountForm";
